import React from "react";
import BarraSupDent from "../../commons/BarraSupDent";
import Title from "../Login/Components/title/title";
import "../Photos/Components/SearchImg.css";
import ImageUpload from "./Components/ImageUpload";
import { Link } from "react-router-dom";
import NavbarDownConsumer from "../../commons/NavbarDownConsumer";

class Photos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      img1: null,
      img2: null,
      img3: null,
    };
  }

  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        ele.classList.add("available");
        setTimeout(() => {
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  successChargeImage = (url, imageId) => {
    if (imageId === "img1") {
      this.setState({
        img1: url,
      });
      sessionStorage.setItem("img1", url);
    }

    if (imageId === "img2") {
      this.setState({
        img2: url,
      });
      sessionStorage.setItem("img2", url);
    }

    if (imageId === "img3") {
      this.setState({
        img3: url,
      });
      sessionStorage.setItem("img3", url);
    }

    if (this.state.img1 && this.state.img2 && this.state.img3) {
      document.getElementById("buttonPhoto").disabled = false;
    }
  };

  failChargeImage(error) {
    alert(error);
    this.setState({
      imageId: null,
    });
    document.getElementById("buttonPhoto").disabled = true;
  }

  render() {
    return (
      <React.Fragment>
        <BarraSupDent />
        <Title text1="Please upload three photos from a variety of angles and distances." />
        <div className="mt-2 mb-2">
          <ImageUpload
            id="img1"
            successImage={this.successChargeImage}
            failImage={this.failChargeImage}
          />
          <br />
          <ImageUpload
            id="img2"
            successImage={this.successChargeImage}
            failImage={this.failChargeImage}
          />
          <br />
          <ImageUpload
            id="img3"
            successImage={this.successChargeImage}
            failImage={this.failChargeImage}
          />
          <br />
        </div>
        <div className="text-center mb-5">
          <Link to="/location">
            <button
              id="buttonPhoto"
              className="btn btn-secondary mx-auto"
              disabled={true}
            >
              Next step
            </button>
          </Link>
        </div>
        <div>
          <br />
          <br />
        </div>
        <NavbarDownConsumer />
      </React.Fragment>
    );
  }
}

export default Photos;
